<template>
    <div class="login-wrap">
		<div style="position:absolute;left:50%;top:50%;width:350px;margin-left:-182px;margin-top:-215px;z-index:9999">
			<img src="../../assets/img/q1.png" style="width:128px;height:64px;"/>
		</div>
		<div class="ms-container">
			<div class="ms-login">
				<div class="ms-title">综合业务管理系统</div>
				<el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
					<el-form-item prop="userName">
						<el-input v-model="param.userName" ref="userName" placeholder="用户名" @keyup.enter.native="$refs.password.focus()">
							<el-button slot="prepend" icon="el-icon-lx-people"></el-button>
						</el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input
							type="password"
							ref="password"
							placeholder="密码"
							v-model="param.password" @keyup.enter.native="$refs.verificationCode.focus()">
							<el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
						</el-input>
					</el-form-item>
					<el-form-item prop="verificationCode">
					<el-input class="login-verification-code" 
							ref="verificationCode"
							placeholder="验证码"
							v-model="param.verificationCode"
							@keyup.enter.native="submit()"
						></el-input>
					<div style="padding-left:210px;"><img title="点击刷新" style = "width:70px;border:solid 1px silver; height:29px;cursor:pointer;float:left" id="verifycode" src = "" @click="refreshVerifyCode();">
						<span effect="plain" style="float:left;width:5px;margin-left:8px;color:#324157">{{ calculagraph > 0?calculagraph:"" }}</span></div>
					</el-form-item>
					<div class="login-btn">
						<el-button type="primary" @click="submit()">登录</el-button>
					</div>
				</el-form>
			</div>
			
			<Vcode :show="vcodeVisible" @success="handleSuccess" @close="handleFail" style="z-index:10000"/>
		</div>
    </div>
</template>

<script>
import { login, getSessionId, getVerifyCode } from '../../api/index';
import Vcode from "vue-puzzle-vcode";
export default {
    data: function() {
		//localStorage.removeItem('ms_token');
		//localStorage.removeItem('ms_ukey');
		//localStorage.removeItem('ms_dkey');
		//localStorage.removeItem('ms_ckey');
		//localStorage.removeItem('ms_currentUserName');
		//localStorage.removeItem("ms_menus");
		//localStorage.removeItem("ms_controlls");
		//localStorage.removeItem('ms_currentPortrait');
		//localStorage.removeItem('ms_currentRoleName');
		//localStorage.removeItem('ms_currentLastLoginTime');		
		
        return {
            param: {
                userName: '',
                password: '',
				verificationCode : ''
            },
            rules: {
                userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
				verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
            },
			target:this.$route.query.target,
			vcodeVisible:false,
			retry:false,
			calculagraph:0,
			timer:undefined,
			imgDisabled:false
        };
    },
	watch: {
		// 监听路由对象$route的变化
		'$route': {
			handler: function (to, from) {
				this.target = this.$route.query.target;
			},
			// 设置为深度监听
			deep: true
		}
    },
	mounted() {
		this.pageLoad();
    },
	components: {
		Vcode,
	},
    methods: {
		pageLoad() {
			if (!localStorage.getItem('ms_token')) {
				setTimeout(this.refreshVerifyCode, 1000);
			} else {
				this.redirectTo();
			}
		},
		submitForm() {
            this.$refs.login.validate(valid => {
				if (valid) {
					login(this.param).then(res => {
						if (res.code == 0) {
							this.$message.success('登录成功');
							localStorage.setItem('ms_token', res.data.token);
							localStorage.setItem('ms_ukey', res.data.ukey);
							localStorage.setItem('ms_ckey', res.data.ckey);
							localStorage.setItem('ms_dkey', res.data.dkey);
							localStorage.setItem('ms_currentUserName', res.data.realName?res.data.realName:res.data.username);
							localStorage.setItem('ms_menus', res.data.permissions.menus);
							localStorage.setItem('ms_controlls', res.data.permissions.controlls);
							localStorage.setItem('ms_currentPortrait', res.data.portrait);
							localStorage.setItem('ms_currentRoleName', res.data.roleName);
							localStorage.setItem('ms_currentLastLoginTime', res.data.lastLoginTime);
							this.redirectTo();
						} else {
							this.$message.error(res.message);
							this.retry = true;
							this.refreshVerifyCode();
							return false;
						}
					});
				} else {
					this.$message.error('登录信息不完整！');
				}
			});
        },
		redirectTo() {
			if (this.target) {
				this.$router.push(this.target);
			} else {
				if (window.location.host.startsWith("system")) {
					this.$router.push('/index');
				} else {
					this.$router.push('/');
				}
			}
		},
		refreshVerifyCode() {
			getSessionId(new Date().getTime()).then(res => {
				if (this.imgDisabled) {
					return;
				}
				let img = document.getElementById("verifycode");
				if (res.code == 0) {
					img.src = '/blob/user/get-verify-code?sessionId=' + res.data + '&t=' + new Date().getTime();
				} else {
					this.$message.error('获取图片参数失败');
				}
				this.imgDisabled = true;
				img.style.cursor="default";
				this.calculagraph = 10;
				this.startCountdown();
			})	
		},
		startCountdown() {
			this.timer = setInterval(() => {
				if (this.calculagraph > 0) {
					this.calculagraph -= 1;
				} else {
					clearInterval(this.timer); // 倒计时结束，清除定时器
					this.imgDisabled = false;
					document.getElementById("verifycode").style.cursor = "pointer";
				}
			}, 1000); // 每秒更新一次
		},
		beforeDestroy() {
			clearInterval(this.timer); // 组件销毁前清除定时器，防止内存泄漏
		},
		submit() {
			if (this.retry) {
				this.$refs.login.validate(valid => {
					if (valid) {
						this.vcodeVisible = true;
					} else {
						this.$message.error('登录信息不完整！');
					}
				});
			} else {
				this.submitForm();
			}
		},
		handleSuccess() {
			this.submitForm();
			this.vcodeVisible = false;
		},
		handleFail() {
			this.vcodeVisible = false;
		}
    }
};
</script>
<!--background-image: url(../../assets/img/login-bg.jpg);-->
<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    
    background-size: 100%;
}

.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
}
.ms-login1 {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}

.ms-login {
	width: 360px;
	height:320px;
	margin-top:60px;
	margin-bottom:50px;
	margin-left:33px;
    background: rgba(255, 255, 255, 0.45);
    overflow: hidden;
}

.ms-container {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 425px;
    margin: -230px 0 0 -212px;
	border-radius: 5px;
    background: rgba(255, 255, 255, 0.05);
    overflow: hidden;
}

.ms-content {
    padding: 30px 30px;
}
.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
.login-verification-code {
	width:200px;
	float:left;
}
</style>